import { S3Client, PutObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

const REGION = "ap-south-2";
const BUCKET = "cedeesflashb";
const IDENTITY_POOL_ID = "ap-south-2:816fc6f2-9487-4806-9317-eaa2f854464b";

if (!REGION || !BUCKET || !IDENTITY_POOL_ID) {
  throw new Error("AWS S3 environment variables are not set");
}

const s3Client = new S3Client({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: REGION },
    identityPoolId: IDENTITY_POOL_ID,
  }),
});

export async function uploadFileToS3(file, key) {
  try {
    const arrayBuffer = await file.arrayBuffer();
    const body = new Uint8Array(arrayBuffer); // ✅ fix for TS

    const params = {
      Bucket: BUCKET,
      Key: key,
      Body: body,
      ContentType: file.type,
      ACL: "public-read",
    };

    await s3Client.send(new PutObjectCommand(params));

    return `https://${BUCKET}.s3.${REGION}.amazonaws.com/${key}`;
  } catch (err) {
    console.error("S3 upload error:", err);
    throw new Error("Failed to upload to S3");
  }
}
